import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCopy } from '@fortawesome/free-solid-svg-icons';
import './NotificationConnecctionKpi.css';

const NotificationConnecctionKpi = ({ message, isVisible, onClose, men1, enca }) => {

    const [title, setTitle] = useState('Guardado Correctamente');

    useEffect(() => {
        if (enca) {
            setTitle(enca);
        }
    }, [enca]);

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        alert("Copiado al portapapeles");
    };

    return (
        isVisible && (
            <div className="info-notification-info-overlay-contract">
                <div className="info-notification-inf-contract">
                    <div className="icon-container-noti-info">
                        <FontAwesomeIcon icon={faCircleCheck} className="icon-noti3" />
                    </div>
                    <div className="message-container-info">
                        <h4>{title}</h4>
                            <div className="message-content">
                                <p>{message}</p>
                            </div>
                        <div className="reg-container">
                            {men1 && (
                                <div className="reg-item">
                                    <span className="reg-content">Registro:<br />
                                        {men1.split("\n").map((line, index) => (
                                            <React.Fragment key={index}>
                                                {line}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                    </span>
                                    <FontAwesomeIcon
                                        icon={faCopy}
                                        className="basic-shortcut-icon"
                                        onClick={() => handleCopy(men1)}
                                        title="Copiar Registro 1"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="button-container-info">
                        <button className="ok-btn-info" onClick={onClose}>
                            OK
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default NotificationConnecctionKpi;
